import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/NashiRaboti.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Добавлен импорт

class NashiRaboti extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      formname: ``,
      show_feedback: false,
      lightboxController: { // Добавлено состояние для лайтбокса
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = ( formname ) => {
    this.setState({ show_feedback: true, formname: formname });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  // Добавлен обработчик для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, assets_path } = this.props,
    { show_feedback, formname, lightboxController } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={`Наши работы`}
            text={``}
          />
          
          {/* Добавлен компонент лайтбокса */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={list.map(item => item.full || item.image)}
            slide={lightboxController.slide}
          />

          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={1}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                // Инициализация активного индекса при загрузке
                this.setState({ activeIndex: swiper.realIndex })
              }}
            >
              {list.map( ( slyde, index ) => (
                <SwiperSlide key={index}>
                  <div className={styles.slyde}>
                    {/* Добавлен обработчик клика для открытия лайтбокса */}
                    <Image src={slyde?.image} width={326} height={243} alt={slyde?.name} onClick={() => this.openLightbox(index)} style={{cursor: 'pointer'}} />
                    <div className={styles.slyde_content}>
                      <div className={styles.slyde_title}>
                        <div dangerouslySetInnerHTML={{__html: slyde?.name}} />
                        <GreenButton
                          text={`Хочу также`}
                          width={120}
                          action={() => this.showFeedback( slyde?.name )}
                        />
                      </div>
                      <div className={styles.slyde_content_blocks}>
                        <div className={styles.slyde_content_blocks_elm}>
                          <div className={styles.slyde_content_blocks_icon}>
                            <Image src={`/${assets_path}/images/edit.svg`} width={15} height={15} alt={`Задача`} />
                          </div>
                          <div className={styles.slyde_content_blocks_title}>Задача</div>
                          <div className={styles.slyde_content_blocks_text} dangerouslySetInnerHTML={{__html: slyde?.zadacha}} />
                        </div>
                        <div className={styles.slyde_content_blocks_elm}>
                          <div className={styles.slyde_content_blocks_icon}>
                            <Image src={`/${assets_path}/images/format-square.svg`} width={15} height={15} alt={`Решение`} />
                          </div>
                          <div className={styles.slyde_content_blocks_title}>Решение</div>
                          <div className={styles.slyde_content_blocks_text} dangerouslySetInnerHTML={{__html: slyde?.reshenie}} />
                        </div>
                        <div className={styles.rtext}>
                          <div className={styles.rtext_iconblock}>
                            <Image src={`/${assets_path}/images/empty-wallet.svg`} width={24} height={24} alt={`Ц`} />
                            <div>
                              <div className={styles.rtext_iconblock_title}>Цена</div>
                              <div className={styles.rtext_iconblock_text} dangerouslySetInnerHTML={{__html: slyde?.price}} />
                            </div>
                          </div>
                          <div className={styles.rtext_iconblock_sep} />
                          <div className={styles.rtext_iconblock}>
                            <Image src={`/${assets_path}/images/box-timeg.svg`} width={24} height={24} alt={`Р`} />
                            <div>
                              <div className={styles.rtext_iconblock_title}>{slyde?.mtitle}</div>
                              <div className={styles.rtext_iconblock_text} dangerouslySetInnerHTML={{__html: slyde?.mtext}} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ) )}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
            <FeedbackForm
              title={formname}
              text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
              btn={`Отправить`}
              data={[]}
              show={show_feedback}
              handleClose={() => this.closeFeedback()}
            />
          </div>
        </Container>
      </section>
    )
  }
}

NashiRaboti.propTypes = {
  list: PropTypes.array,
  assets_path: PropTypes.string
}

NashiRaboti.defaultProps = {
  list: [],
  assets_path: ``
}

export default NashiRaboti